import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

export interface AppConfig {
  inputStyle: string;
  colorScheme: string;
  theme: string;
  ripple: boolean;
  menuMode: string;
  scale: number;
  menuTheme: string;
}

interface LayoutState {
  staticMenuDesktopInactive: boolean;
  overlayMenuActive: boolean;
  rightMenuVisible: boolean;
  configSidebarVisible: boolean;
  staticMenuMobileActive: boolean;
  menuHoverActive: boolean;
  searchBarActive: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class LayoutService {
  public config$ = new BehaviorSubject<AppConfig>({
    ripple: false,
    inputStyle: 'outlined',
    menuMode: 'static',
    colorScheme: 'light',
    theme: 'blue',
    menuTheme: 'darkgray',
    scale: 12,
  });

  public state: LayoutState = {
    staticMenuDesktopInactive: false,
    overlayMenuActive: false,
    rightMenuVisible: false,
    configSidebarVisible: false,
    staticMenuMobileActive: false,
    menuHoverActive: false,
    searchBarActive: false,
  };

  private configUpdate = new Subject<AppConfig>();

  private overlayOpen = new Subject<any>();

  public configUpdate$ = this.configUpdate.asObservable();

  public overlayOpen$ = this.overlayOpen.asObservable();

  public onMenuToggle() {
    if (this.isOverlay()) {
      this.state.overlayMenuActive = !this.state.overlayMenuActive;

      if (this.state.overlayMenuActive) {
        this.overlayOpen.next(null);
      }
    }

    if (this.isDesktop()) {
      this.state.staticMenuDesktopInactive = !this.state.staticMenuDesktopInactive;
    } else {
      this.state.staticMenuMobileActive = !this.state.staticMenuMobileActive;

      if (this.state.staticMenuMobileActive) {
        this.overlayOpen.next(null);
      }
    }
  }

  public onOverlaySubmenuOpen() {
    this.overlayOpen.next(null);
  }

  public showRightMenu() {
    this.state.rightMenuVisible = true;
  }

  public showConfigSidebar() {
    this.state.configSidebarVisible = true;
  }

  public toggleSearchBar() {
    this.state.searchBarActive = !this.state.searchBarActive;
  }

  public isOverlay() {
    return this.config$.getValue().menuMode === 'overlay';
  }

  public isDesktop() {
    return window.innerWidth > 991;
  }

  public isSlim() {
    return this.config$.getValue().menuMode === 'slim';
  }

  public isCompact() {
    return this.config$.getValue().menuMode === 'compact';
  }

  public isHorizontal() {
    return this.config$.getValue().menuMode === 'horizontal';
  }

  public isMobile() {
    return !this.isDesktop();
  }

  public onConfigUpdate() {
    // this.configUpdate.next(this.config);
  }
}
